export interface IQuickNavigationItem {
  /** id of the element on the page that the item jumps to */
  anchorId: string,
  label: string,
  /** items with the same group are listed below its title; items without a group are listed first */
  group?: string,
  count?: number,
  /** secondary text shown after the label when it has no count, e.g. a date */
  detail?: string,
}

/** The URL hash of an anchor, e.g. `#spacing`. */
export function createAnchorHash(anchorId: string): string {
  return `#${anchorId}`;
}

/** The anchor of a URL hash, the reverse of `createAnchorHash`. */
export function parseAnchorHash(hash: string): string {
  return decodeURIComponent(hash.replace(/^#/, ''));
}
